import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { metaDataCode, metaDataCodeResponse } from "./MetadataData/MetaDataCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const MetadataComponent = () => {
    const [selectedLanguageMetaData, setSelectedLanguageMetadata] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageMetadata(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'metadata' ? metaDataCode[selectedLanguageMetaData].request : metaDataCodeResponse;
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setCopyStatus({ type, isCopied: true });
                setTimeout(() => {
                    setCopyStatus({ type: '', isCopied: false });
                }, 1000);
            })
            .catch((error) => {
                console.error('Error copying text: ', error);
                alert('Failed to copy text. Please try again.');
            });
    };

    return (
        <section className="docs-section" id="item-4-1">
          <p><span className="badge badge-secondary back-blue">GET</span><span className="api"> /in-store/api/v1/metadata</span></p>
          <p>Service to retrieve meta data</p>
          <div className="row flexbox">

            <div className="col-md-5 col-sm-12 col-xs-12">

              <br />

              <div className="response-codes">

                <h4>Response Codes</h4>

                <div className="table-wrapper">

                  <h6 className="header">HTTP Status code summary</h6>

                  <table>
                    <tbody>
                      <tr>
                        <td>200 Success</td>
                        <td>Metadata retrieved successfully</td>
                      </tr>
                      <tr>
                        <td>401 Unauthorized</td>
                        <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header</td>
                      </tr>
                    </tbody>
                  </table>

                </div>

              </div>

            </div>

            <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(metaDataCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langMetaData" id={`${language}MetaData`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageMetaData === language} />
                                                <label htmlFor={`${language}MetaData`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'metaData' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("metaData")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'metaData' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageMetaData]} style={dracula} showLineNumbers>
                                        {metaDataCode[selectedLanguageMetaData].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'metaDataResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("metaDataResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'metaDataResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {metaDataCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>
          </div>
        </section>
    );
};

export default MetadataComponent;
